import React from 'react';
import { components } from 'react-select';

const NewValueContainer = (props) => {
  const { children, selectProps } = props;

  return (
    <components.ValueContainer {...props}>
      {/*
        Loop through the given children. If the child is a SingleValue component,
        show the placeholder instead. If not, show the child. This prevents the
        ValueContainer from displaying results, but still retains the rest of the
        component's default functionality (event handlers, focus control, etc)
      */}
      {React.Children.map(children, (child) => {
        if (child && child.type !== components.SingleValue) {
          return child;
        }

        return (
          <components.Placeholder
            {...props}
            key="placeholder"
            isDisabled={selectProps.isDisabled}
            data={props.getValue()}
          >
            {selectProps.placeholder}
          </components.Placeholder>
        );
      })}
    </components.ValueContainer>
  );
};

export default NewValueContainer;
